import cn from 'classnames'
import { ButtonHTMLAttributes, forwardRef } from 'react'

import { MARK } from '../utils'
import styles from './MarkButton.module.scss'

type MarkButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean
  value?: MARK
}

const MarkButton = forwardRef<HTMLButtonElement, MarkButtonProps>(
  ({ onClick, value, children, active, className, ...props }, ref) => {
    const rootClassName = cn(styles.root, { [styles.active]: active }, className)

    return (
      <button ref={ref} onClick={onClick} data-value={value} className={rootClassName} {...props}>
        {children}
      </button>
    )
  }
)

export default MarkButton
